<template>
  <div class="container">
    <div class="content">
      <div class="desBox">
        <h3>什么是智慧打印？</h3>
        <p>
          福昕智慧打印突破企业传统打印模式，一机安装，即刻实现全员跨平台、跨网络、跨区域共享打印。强大的打印管理功能，涵盖设备耗材预警、全员数据统计、打印明细管理、分级权限管理等多项管理，打印情况一目了然，轻松实现智慧管控。
        </p>
        <ul class="other">
          <li>
            <a
              href="https://www.foxitsoftware.cn/dayin/help.html?from=dy"
              target="_blank"
            >
              <img :src="require('img/compass.png')" alt="" /><span
                >详细使用指南</span
              >
            </a>
          </li>
          <li>
            <a
              href="https://file.foxitreader.cn/file/Channel/foxitprinter/print01_FoxitprinterSetup.exe"
            >
              <img :src="require('img/download.png')" alt="" /><span
                >下载福昕智慧打印客户端</span
              >
            </a>
          </li>
        </ul>
      </div>
      <img class="bannerImg" src="~@/assets/img/banner.png" alt="" />
    </div>
    <div>
      <div class="btnBox" @click="showUploadPopupFn">
        <div><span>立即打印</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showUploadPopupFn() {
      this.$emit("showUploadPopupFn");
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  .content {
    max-width: 1200px;
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;
    padding-right: 60px;
    border-bottom: 1px solid #eeeeee;
    .desBox {
      width: 476px;
      h3 {
        line-height: 30px;
        font-weight: bold;
        font-size: 30px;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #424242;
        margin-bottom: 34px;
      }
      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: #666666;
        margin-bottom: 18px;
      }
      .other {
        display: flex;
        align-content: center;
        li {
          display: flex;
          align-items: center;
          margin-right: 65px;
          cursor: pointer;
          a {
            display: flex;
            align-items: center;
            &:hover {
              text-decoration: underline !important;
              color: $theme-color;
            }
          }
          img {
            margin-right: 6px;
            height: 20px;
          }
          span {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: $theme-color;
          }
        }
      }
    }
    .bannerImg {
      width: 276px;
      height: 239px;
    }
  }
}

.btnBox {
  position: relative;
  cursor: pointer;
  width: 180px;
  div {
    width: 180px;
    height: 48px;
    background-image: url("~@/assets/img/btn.png");
    &:hover {
      background-image: url("~@/assets/img/btn_.png");
    }
  }
  span {
    position: absolute;
    height: 48px;
    line-height: 48px;
    left: 30px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
  }
}
</style>
